import { render, staticRenderFns } from "./EditOrder.vue?vue&type=template&id=4d1fc630&"
import script from "./EditOrder.vue?vue&type=script&lang=js&"
export * from "./EditOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports